/*
 * Help & Advice search. Loads the JSON index once (/pages/help-advice?view=help-search) and
 * searches questions, keywords, category and answers in the browser.
 * Every word must match the start of a word somewhere; case and accents are ignored.
 */
(function () {
  if (window.__helpAdviceSearch) return;
  window.__helpAdviceSearch = true;

  var WEIGHTS = { q: 5, k: 4, c: 2, t: 1 };
  var MAX_RESULTS = 8;
  var indexes = {};

  // NFD + stripping combining marks keeps string length for precomposed letters,
  // so positions in the normalised text map back to the original for snippets.
  function norm(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function escapeHtml(s) {
    return s.replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function escapeRe(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function load(url) {
    if (!indexes[url]) {
      indexes[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (txt) {
          return JSON.parse(txt).map(function (it) {
            it.n = { q: norm(it.q), k: norm((it.k || []).join(' · ')), c: norm(it.c + ' ' + it.a), t: norm(it.t) };
            return it;
          });
        })
        .catch(function () { delete indexes[url]; return []; });
    }
    return indexes[url];
  }

  function tokens(query) {
    return norm(query).split(/[^a-z0-9]+/).filter(Boolean).map(function (w) {
      // "tiles" should find "tile", "grouts" should find "grout"
      return w.length > 3 && /[^s]s$/.test(w) ? w.slice(0, -1) : w;
    });
  }

  function wordRe(tok) {
    return new RegExp('(^|[^a-z0-9])' + escapeRe(tok));
  }

  function search(items, query) {
    var toks = tokens(query);
    if (!toks.length) return [];
    var res = toks.map(wordRe);
    var phrase = norm(query).trim();
    var hits = [];
    items.forEach(function (it) {
      var score = 0;
      for (var i = 0; i < res.length; i++) {
        var best = 0;
        for (var f in WEIGHTS) if (WEIGHTS[f] > best && res[i].test(it.n[f])) best = WEIGHTS[f];
        if (!best) return;
        score += best;
      }
      if (phrase.length > 2 && it.n.q.indexOf(phrase) !== -1) score += 5;
      hits.push({ it: it, score: score });
    });
    hits.sort(function (a, b) { return b.score - a.score || a.it.q.localeCompare(b.it.q); });
    return hits;
  }

  function highlight(text, toks) {
    var ntext = norm(text);
    var ranges = [];
    toks.forEach(function (tok) {
      var re = new RegExp('(^|[^a-z0-9])(' + escapeRe(tok) + '[a-z0-9]*)', 'g');
      var m;
      while ((m = re.exec(ntext))) {
        var start = m.index + m[1].length;
        ranges.push([start, start + m[2].length]);
        if (m[0].length === 0) re.lastIndex++;
      }
    });
    ranges.sort(function (a, b) { return a[0] - b[0]; });
    var out = '', pos = 0;
    ranges.forEach(function (r) {
      if (r[0] < pos) return;
      out += escapeHtml(text.slice(pos, r[0])) + '<mark>' + escapeHtml(text.slice(r[0], r[1])) + '</mark>';
      pos = r[1];
    });
    return out + escapeHtml(text.slice(pos));
  }

  function snippet(text, toks) {
    var ntext = norm(text);
    var at = -1;
    for (var i = 0; i < toks.length && at < 0; i++) {
      var m = wordRe(toks[i]).exec(ntext);
      if (m) at = m.index;
    }
    if (at < 0) at = 0;
    var start = Math.max(0, at - 60);
    var end = Math.min(text.length, start + 180);
    var s = text.slice(start, end);
    return (start > 0 ? '… ' : '') + highlight(s, toks) + (end < text.length ? ' …' : '');
  }

  function render(box, hits, query) {
    var toks = tokens(query);
    if (!hits.length) {
      box.innerHTML = '<p class="ha-empty">No answers found for “' + escapeHtml(query) + '”.</p>';
      return;
    }
    box.innerHTML = '<ul>' + hits.slice(0, MAX_RESULTS).map(function (h) {
      var it = h.it;
      return '<li><a href="' + escapeHtml(it.u) + '">' +
        '<span class="ha-r-meta">' + escapeHtml(it.a + ' / ' + it.c) + '</span>' +
        '<span class="ha-r-q">' + highlight(it.q, toks) + '</span>' +
        '<span class="ha-r-s">' + snippet(it.t, toks) + '</span>' +
        '</a></li>';
    }).join('') + '</ul>';
  }

  function init(root) {
    var input = root.querySelector('[data-ha-input]');
    var box = root.querySelector('[data-ha-results]');
    var url = root.getAttribute('data-index');
    var timer;

    function run() {
      var query = input.value;
      if (!query.trim()) { box.innerHTML = ''; return; }
      load(url).then(function (items) {
        if (input.value !== query) return;
        render(box, search(items, query), query);
      });
    }

    input.addEventListener('focus', function () { load(url); }, { once: true });
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 120); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var first = box.querySelector('a');
        if (first) window.location.href = first.href;
      } else if (e.key === 'Escape') {
        input.value = '';
        box.innerHTML = '';
      }
    });

    var q = new URLSearchParams(window.location.search).get('q');
    if (q && root.classList.contains('ha-search--lg')) { input.value = q; run(); }
  }

  function start() {
    document.querySelectorAll('[data-ha-search]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
